import { IconChevronRight } from '@tabler/icons-react';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

export const GeoShow = ({ text, ...props }: { text: string }) => {
  return (
    <Button
      {...props}
      variant='ghost'
      className='h-[46px] w-full justify-between gap-[4px] px-0 text-secondary hover:bg-transparent min-w-0'
    >
      <div className='flex gap-[12px] items-center min-w-0 flex-1'>
        <div className='rounded-[50%] bg-surface-neutral w-[46px] h-[46px] flex items-center justify-center shrink-0'>
          <Image width={16} height={16} alt='geo' src='/assets/icons/map-pin.svg' className='h-[24px] w-[24px]' />
        </div>

        <span className='text-[16px] text-primary font-medium whitespace-nowrap overflow-hidden text-ellipsis block min-w-0 '>
          {text}
        </span>
      </div>

      <IconChevronRight className='text-icon-default' size={20} />
    </Button>
  );
};
